module.exports = "\r\n\r\n\r\n\r\n.countdown-timer {\r\n    font-size: 2em;\r\n    font-weight: bold;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n}\r\n\r\n#idleTimeoutDialog {\r\n    top: 25%; \r\n    z-index:9999; \r\n}\r\n\r\n.banner-container {\r\n  position: absolute;\r\n  top: 0;\r\n  height: 70px;\r\n  width:100%;\r\n}\r\n\r\n.body-container {\r\n  position: absolute;\r\n  top: 70px;\r\n  bottom: 0;\r\n  width: 100%;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main